export default "__VITE_ASSET__BdouXak7__"